import { useCallback, useState } from 'react';
import api from '../utils/api.util';
import toast from '../utils/toast.util';
import { ENDPOINT } from '../constants/common-app.const';

const useSubmitContract = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submitContract = useCallback(async (contractId: string): Promise<{ contractNumber: string }> => {
    try {
      setLoading(true);
      const response = await api.postJson(
        `${ENDPOINT.CONTRACTS}/${contractId}/submit`,
        {}
      );
      setLoading(false);
      return { contractNumber: response.contractNumber };
    } catch (err: any) {
      const status = err?.statusCode ?? err?.status;
      if (status === 422) {
        // Show backend validation message directly (e.g. inactive UNP — per UI-SPEC §2.4.5)
        const backendMsg = err?.error ?? err?.message ?? 'Ошибка подачи договора';
        toast.showOnFailure(backendMsg);
      } else {
        toast.showOnFailure('Ошибка подачи договора');
      }
      setError('submit failed');
      setLoading(false);
      throw err;
    }
  }, []);

  return { submitContract, loading, error };
};

export default useSubmitContract;
